import { Component, HostBinding, inject, input } from '@angular/core';
import { iaIconCheckRounded, iaIconCircleCheckFilled } from '@bcef/ia-icons';
import { iaIconCrossLarge } from '@bcef/ia-icons/nhb';
import { IconComponent, provideIcons } from '@bcef/ia-ng-icons';
import { ContextService } from '@bcef/ia-shared';
import { TranslatePipe } from '@ngx-translate/core';
import { clsx } from 'clsx';

import { ReportStore } from '@core/store/report.store';

@Component({
  selector: 'ia-report-technical-problem-attachment, li[ia-report-technical-problem-attachment]',
  template: `
    <ia-icons
      [name]="context.isHbGroup ? 'check_rounded' : 'circle_check_filled'"
      class="tw-size-5 hbpro:tw-text-primary mb-group:tw-text-primary"
    />
    <div class="hb-group:tw-flex hb-group:tw-w-full hb-group:tw-justify-between">
      <p class="tw-text-base tw-font-bold">{{ file().name }}</p>
      <button
        class="tw-inline-block tw-text-base tw-font-semibold mb-group:tw-text-primary mb-group:tw-underline hb-group:tw-size-5"
        data-test-id="delete-attachment"
        [ariaLabel]="'Supprimer la capture ' + file().name"
        [title]="'Supprimer la capture ' + file().name"
        (click)="onRemoveAttachment($event)"
      >
        @if (context.isMbGroup) {
          {{ 'screens.description.panel.content.form.attachment.list.remove' | translate }}
        } @else {
          <ia-icons name="nhb:cross_large" />
        }
      </button>
    </div>
  `,
  imports: [TranslatePipe, IconComponent],
  providers: [provideIcons(iaIconCircleCheckFilled, iaIconCheckRounded, iaIconCrossLarge)],
})
export class AttachmentComponent {
  protected readonly store = inject(ReportStore);

  protected readonly context = inject(ContextService);

  public readonly file = input.required<File>();

  protected onRemoveAttachment(event: PointerEvent): void {
    event.preventDefault();
    return this.store.removeAttachment(this.file());
  }

  @HostBinding('class')
  public classAttributes = clsx([
    'tw-flex',
    'tw-items-center',
    'tw-gap-3',
    'hb-group:tw-bg-black-squeeze',
    'hb-group:tw-p-4',
    'hb-group:tw-rounded-xl',
  ]);
}
